import { IPersonalInfo } from '../../../types';
export type PersonalInfoState = IPersonalInfo

export enum PersonalInfoActionTypes {
  UPDATE_PI_FIELD = '@@visa/personalInfo/UPDATE_PI_FIELD'
}

export enum Pages {
  PAGE1 = 'student-pi-step1',
  PAGE2 = 'student-pi-step2',
  PAGE3 = 'student-pi-step3',
  PAGE4 = 'student-pi-step4',
  PAGE5 = 'student-pi-step5',
  PAGE5_1 = 'student-pi-step5_1',
  PAGE6 = 'student-pi-step6',
  PAGE7 = 'student-pi-step7',
  PAGE8 = 'student-pi-step8',
  PAGE9 = 'student-pi-step9',
  PAGE10 = 'student-pi-step10'
}
